import { Navigate } from "react-router-dom";
import { useDemoMode } from "../../context/DemoModeContext";

/**
 * Redirige vers /demo si la barrière démo est active et qu’aucun jeton n’est présent.
 * Si le mode démo est désactivé côté API, /demo renvoie vers l’accueil.
 */
export default function DemoRouteGate({ children }) {
  const { statusLoading, demoEnabled, demoGate, isDemoSession, pathname } = useDemoMode();

  if (pathname.startsWith("/admin") || pathname.startsWith("/dev")) {
    return children;
  }

  if (statusLoading) {
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center text-sm text-gray-500">
        Chargement de l&apos;espace…
      </div>
    );
  }

  if (pathname === "/demo") {
    return children;
  }

  if (demoEnabled && demoGate && !isDemoSession) {
    return <Navigate to="/demo" replace />;
  }

  if (!demoEnabled && pathname === "/demo") {
    return <Navigate to="/" replace />;
  }

  return children;
}
